import { render, staticRenderFns } from "./ClaimListItem.vue?vue&type=template&id=6e5668c7&"
import script from "./ClaimListItem.vue?vue&type=script&lang=js&"
export * from "./ClaimListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports